import { ReactNode } from 'react'
import { Skeleton } from '@systemeio/components'

export const PostAnnounceSkeleton = (): ReactNode => (
  <div className="mb-10 overflow-hidden rounded-lg bg-bg-primary">
    <div className="w-full p-5 lg:px-16 lg:py-10">
      <div className="mb-4 flex items-center gap-2">
        <Skeleton className="size-6 rounded-full" />
        <Skeleton className="h-4 w-14 rounded-xs" />
        <Skeleton className="h-4 w-14 rounded-xs" />
      </div>
      <Skeleton className="mb-2 h-7 rounded-xs" />
      <Skeleton className="mb-5 h-7 w-3/4 rounded-xs" />
      {[...Array.from({ length: 6 }).keys()].map(index => (
        <Skeleton className="mb-3 h-3 rounded-xs" key={index} />
      ))}
    </div>
    <hr className="mx-5 px-5 text-text-secondary/30 lg:mx-0" />
    <div className="flex w-full justify-between p-5 lg:px-16 lg:py-10">
      <div className="flex gap-4">
        <div className="flex items-center gap-2">
          <Skeleton className="size-6 rounded-full" />
          <Skeleton className="h-4 w-14 rounded-xs" />
        </div>
        <div className="flex items-center gap-2">
          <Skeleton className="size-6 rounded-full" />
          <Skeleton className="h-4 w-14 rounded-xs" />
        </div>
      </div>
      <div className="">
        <Skeleton className="h-6 w-20 rounded-xs" />
      </div>
    </div>
  </div>
)
